// extracted by mini-css-extract-plugin
module.exports = {"AsteriskExplain":"AsteriskExplain_AsteriskExplain__1sUky"};